import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-contact-us-section',
    templateUrl: './contact-us-section.component.html',
    styleUrls: ['./contact-us-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactUsSectionComponent implements OnInit, OnChanges {
    // @Input() data;
    public data: any;
    public contactFormToggle = false;
    public hubspotFormBoxData;
    @ViewChild('showMore') showMoreSection;
    @Input() portalHubSpotId: string;
    private _$hubspotFormBoxData: BehaviorSubject<any> = new BehaviorSubject(null);
    public path: string;
    public language: string;
    public _formIdValue;
    public translations: any;
    public showHubSpotForm = false;
    private _$loadForm: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showForm: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private _translateService: TranslateService,
        private _configurationService: ConfigurationService
    ) {
        _translateService.get('routes.home').subscribe((res: string) => {
            this.path = res;
        });

        _translateService.get('language').subscribe((res: string) => {
            this.language = res;
        });
    }
    public get loadForm$(): Observable<boolean> {
        return this._$loadForm.asObservable();
    }

    public get showForm$(): Observable<boolean> {
        return this._$showForm.asObservable();
    }

    get hubspotFormBoxData$(): Observable<any> {
        return this._$hubspotFormBoxData.asObservable();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && changes.data.currentValue && changes.data.currentValue !== changes.data.previousValue) {
            this._$hubspotFormBoxData.next(this.data.hubspotFormBoxData);
        }
    }
    ngOnInit() {
        this.path = this.language + this.path;

        if (!this._configurationService.isPartnerPage()) {
            this.showHubSpotForm = true;
            this._setTranslations();
        } else {
            this._setPortalTranslations();
        }
    }
    ngAfterViewInit() {
        setTimeout(function () {
            const hash = window.location.hash;
            if (hash == '#contact') {
                const el = document.getElementById('contact-us');
                const top = el.offsetTop; //Getting Y of target element
                window.scrollTo(0, top);
            }
        }, 500);
    }

    toggleContactForm() {
        this.contactFormToggle = !this.contactFormToggle;
        if (!this._$loadForm.getValue() && this.contactFormToggle) {
            this._$loadForm.next(true);
        }
    }

    private _setPortalTranslations(): void {
        this._translateService.stream('contactSection').subscribe((con) => {
            this.data = con;
            if (typeof this.data === "object") {
                setTimeout(() => {
                    this._$showForm.next(true);                    
                }, 1000);
            }
            this._$hubspotFormBoxData.next(this.data.hubspotFormBoxData);
        });
        this._translateService.stream(['contactSection.labelMore', 'common.labelMore', 'common.labelLess']).subscribe((data) => {
            if (data) {
                this.translations = {
                    labelMore: data['common.labelMore'],
                    labelLess: data['common.labelLess'],
                    buttonLabelMore: data['contactSection.labelMore']
                };
                this.takeHubSpotIdfromPortal();
            }
        });
    }

    private _setTranslations(): void {
        this._translateService.stream('contact').subscribe((con) => {
            this.data = con;
            if (typeof this.data === "object") {
                setTimeout(() => {
                    this._$showForm.next(true);                    
                }, 2000);
            }
            this._$hubspotFormBoxData.next(this.data.hubspotFormBoxData);
        });
        this._translateService.stream(['contact.labelMore', 'common.labelMore', 'common.labelLess']).subscribe((data) => {
            this.translations = {
                labelMore: data['common.labelMore'],
                labelLess: data['common.labelLess'],
                buttonLabelMore: data['contact.labelMore']
            };
        });
    }

    private takeHubSpotIdfromPortal() {
        const hubSpotData = this._$hubspotFormBoxData.getValue();
        if (hubSpotData) {
            if (this.portalHubSpotId) {
                this.showHubSpotForm = true;
                hubSpotData.hubSpotFormID = this.portalHubSpotId;
                this._$hubspotFormBoxData.next(hubSpotData);
            } else {
                this.showHubSpotForm = false;
            }
        }
    }
}
